import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";
import { signInWithGoogle } from "@/utils/auth";

const Careers = () => {
  const navigate = useNavigate();

  const handleSignIn = async () => {
    try {
      await signInWithGoogle();
    } catch (error) {
      console.error('Sign in failed:', error);
    }
  };

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <SEO
        title="Careers at Seoro - Join Our Team | We're Building the Future of SEO Automation"
        description="Join Seoro in building the future of SEO content automation. While we're not actively hiring right now, we're always open to connecting with talented people passionate about SEO, AI, and creating impactful products."
        keywords="Seoro careers, jobs at Seoro, SEO automation jobs, AI engineering jobs, content marketing jobs"
      />
      <Header onSignIn={handleSignIn} />
      
      <main className="flex-1 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-24">
        <div className="space-y-12">
          <div className="text-center space-y-4">
            <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-foreground">
              Careers at Seoro
            </h1>
            <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
              We're building the future of SEO content automation. While we're not actively hiring right now, we're always open to connecting with talented people.
            </p>
          </div>

          <div className="prose prose-lg max-w-none space-y-8">
            <section className="space-y-4">
              <h2 className="text-3xl font-bold text-foreground">Why Work at Seoro?</h2>
              <p className="text-muted-foreground leading-relaxed">
                We're building AI-powered tools that help businesses grow their organic traffic and dominate search rankings. 
                If you're passionate about SEO, AI, and creating products that make a real impact, we'd love to connect—even 
                if we're not actively hiring right now.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-3xl font-bold text-foreground">We're Not Currently Hiring</h2>
              <p className="text-muted-foreground leading-relaxed">
                Right now, we're focused on growing our product and serving our customers. While we don't have open positions 
                at the moment, we're always interested in connecting with talented people who share our vision. If you have 
                expertise in any of these areas, we'd love to hear from you:
              </p>
              <ul className="list-disc list-inside space-y-2 text-muted-foreground">
                <li>Full-stack development (React, TypeScript, Node.js)</li>
                <li>AI/ML engineering and prompt engineering</li>
                <li>SEO and content marketing</li>
                <li>Product design and UX</li>
                <li>DevOps and infrastructure</li>
              </ul>
            </section>

            <section className="space-y-4">
              <h2 className="text-3xl font-bold text-foreground">Get in Touch</h2>
              <p className="text-muted-foreground leading-relaxed">
                Even though we're not actively hiring, we keep a list of talented people for when opportunities arise. 
                If you're interested in working with us in the future, send us an email at{" "}
                <a href="mailto:careers@seoro.so" className="text-primary hover:underline">
                  careers@seoro.so
                </a>{" "}
                with your resume and a brief note about what you'd bring to Seoro. We'll keep your information on file 
                and reach out when we have openings that match your skills.
              </p>
            </section>
          </div>
        </div>
      </main>

      <Footer onSignIn={handleSignIn} />
    </div>
  );
};

export default Careers;


